<template>
  <div class="annexe-form">
    <b-overlay
      id="overlay-background"
      :show="loading"
      :variant="'white'"
      :opacity="0.7"
      :blur="'2px'"
      rounded="sm"
    >
      <ValidationObserver v-slot="{ handleSubmit }">
        <ResourceCreator
          ref="resourceCreator"
          :is-main="false"
          :resource="resource"
          :required="true"
        />
        <b-button
          variant="primary"
          @click="handleSubmit(startAddAnnexe)"
        >
          {{ $t('buttons.add') }}
        </b-button>
      </ValidationObserver>
    </b-overlay>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Resource from '../../models/resource.js';
import ResourceCreator from '@/components/Resource/ResourceCreator.vue';

import { ValidationObserver } from 'vee-validate';

export default {
  name: 'AddAnnexe',

  components: {
    ResourceCreator,
    ValidationObserver
  },

  props: {
    required: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      loading: false,
      form: {},
      resource:new Resource(),
    };
  },

  computed: {
    ...mapState('datasets', [
      'currentDataset'
    ]),
  },

  created() {
    this.resource=new Resource();
  },

  methods: {
 
    startAddAnnexe() {
      this.$emit('added',this.resource);
    },


  }
};
</script>

<style lang="less" scoped>

.annexe-form {
  margin: 0.5em 0 1em 1em;
  // border: 1px solid #ced4da;
}

button {
  float: right;
  margin: 0.5em 0 1em 0;
  padding: 0.3em 2em 0.3em 2em;
  border: 2px solid #9BD0FF;
  border-radius: 8px;
}

</style>
